module.exports = __webpack_public_path__ + "static/fbcampbg.5eb3d7f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/fbcampbg.jpg
// module id = 3112
// module chunks = 58691923486625